import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import Services from "@/pages/public/Services";
import Gallery from "@/pages/public/Gallery";
import Quote from "@/pages/public/Quote";
import About from "@/pages/public/About";
import Privacy from "@/pages/public/Privacy";
import Cookies from "@/pages/public/Cookies";
import Terms from "@/pages/public/Terms";

import Login from "@/pages/admin/Login";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Leads from "@/pages/admin/Leads";
import LeadDetail from "@/pages/admin/LeadDetail";
import Invoices from "@/pages/admin/Invoices";
import InvoiceEditor from "@/pages/admin/InvoiceEditor";
import InvoiceDetail from "@/pages/admin/InvoiceDetail";
import InvoicePrint from "@/pages/admin/InvoicePrint";
import GalleryManage from "@/pages/admin/GalleryManage";
import ServicesManage from "@/pages/admin/ServicesManage";
import ContentManage from "@/pages/admin/ContentManage";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/terms" element={<Terms />} />
            </Route>

            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route
              path="/admin/invoices/:id/print"
              element={
                <ProtectedRoute>
                  <InvoicePrint />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<Leads />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="invoices/new" element={<InvoiceEditor />} />
              <Route path="invoices/:id" element={<InvoiceDetail />} />
              <Route path="invoices/:id/edit" element={<InvoiceEditor />} />
              <Route path="gallery" element={<GalleryManage />} />
              <Route path="services" element={<ServicesManage />} />
              <Route path="content" element={<ContentManage />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
